Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "MultiOfferings3747638281",
  {"root":"MultiOfferings3747638281--root","cardContainer":"MultiOfferings3747638281--cardContainer","cardsContainer":"MultiOfferings3747638281--cardsContainer"},
  "",
  11,
  "MultiOfferings3747638281"
);

